module.exports = __webpack_public_path__ + "img/banneren2.a5a28fc5.png";